import React from 'react';

import { cn } from '../lib/utils';

import useResolvedProfile from '../hooks/useResolvedProfile';
import ProfilePopoverContent from './ProfilePopoverContent';
import EntityPopover from './shared/EntityPopover';
import EntityWrapper from './shared/EntityWrapper';
import Flexicon from './shared/Flexicon';

// Clicking a mention shows the profile popover (via EntityPopover's clickEnabled) — never a DM
// or account settings — so swallow the click before it reaches an interactive ancestor.
const swallowClick = (event) => event?.stopPropagation();

export const ProfileEntity = ({
  profile,
  dataId = null,
  dataTarget = null,
  jumbo = false,
  suggestion = false,
  truncated = false,
  isCurrentProfile = false,
  popoverOnClick = false,
  showAvatar = true,
}) => {
  const clickEnabled = popoverOnClick && !suggestion;
  const resolvedProfile = useResolvedProfile(profile, clickEnabled);
  const unavailable = !resolvedProfile?.id;
  const deactivated = resolvedProfile?.role === 'deactivated';

  const popoverContent = resolvedProfile?.id ? <ProfilePopoverContent profile={resolvedProfile} /> : null;

  return (
    <EntityPopover content={popoverContent} interactive={!suggestion} clickEnabled={clickEnabled}>
      <EntityWrapper
        data-type="profile"
        data-target={dataTarget}
        data-id={dataId}
        jumbo={jumbo}
        suggestion={suggestion}
        truncated={truncated}
        onClick={clickEnabled ? swallowClick : undefined}
        data-app-region={popoverOnClick ? 'none' : undefined}
        className={cn(
          'cursor-default',
          clickEnabled && 'cursor-pointer',
          (deactivated || unavailable) && 'text-gray-400',
        )}
      >
        {showAvatar && (
          <span className={cn('relative top-1', (deactivated || unavailable) && 'saturate-0')}>
            <Flexicon resource={resolvedProfile} size={jumbo ? 'size-10' : 'size-4'} />
          </span>
        )}
        <span className={cn('font-semibold', jumbo && 'text-base', (suggestion || truncated) && 'truncate')}>
          {resolvedProfile?.full_name || (unavailable ? 'Unavailable' : 'Deactivated')}
          {isCurrentProfile && <span className="font-normal text-gray-500 dark:text-neutral-500"> (you)</span>}
        </span>
      </EntityWrapper>
    </EntityPopover>
  );
};
